import React, { useEffect } from 'react';
import api from '../api';
import getAzureSasToken from '../../utils/azureSasToken';

const BuscarImagem = ({ fileId, idRede, onImageLoad }) => {
  const apiUrl = process.env.REACT_APP_API_BASE_33;
  const azureSasToken = getAzureSasToken();

  useEffect(() => {
    const fetchImage = async () => {
      try {
        const isAbsoluteHttpUrl = (value) => /^https?:\/\//i.test(value || '');
        const apiBaseNormalized = `/${String(apiUrl || '').replace(/^\/+|\/+$/g, '')}`;
        const getViewableBlobUrl = (url) => {
          if (!url) return '';
          if (url.includes('blob.core.windows.net') && !url.includes('?') && azureSasToken) {
            return `${url}${azureSasToken}`;
          }
          return url;
        };

        let imageBlob = null;

        if (isAbsoluteHttpUrl(fileId)) {
          const response = await fetch(getViewableBlobUrl(fileId));
          if (!response.ok) {
            throw new Error(`Falha ao buscar imagem direta. Status ${response.status}`);
          }
          imageBlob = await response.blob();
        } else {
          const candidateUrls = [
            `${apiBaseNormalized}/${fileId}?id_rede=${idRede}`,
            `${apiBaseNormalized}/view/${fileId}?id_rede=${idRede}`,
          ];

          let lastError = null;
          for (const url of candidateUrls) {
            try {
              const response = await api.get(url, { responseType: 'blob' });
              imageBlob = response.data;
              break;
            } catch (requestError) {
              lastError = requestError;
            }
          }

          if (!imageBlob) {
            throw lastError || new Error('Falha ao carregar imagem.');
          }
        }

        const imageObjectUrl = URL.createObjectURL(imageBlob);
        onImageLoad(imageObjectUrl); // Passa a URL da imagem para o componente pai
      } catch (err) {
        console.error('Erro ao carregar imagem:', err);
      }
    };

    fetchImage();
  }, [fileId, idRede, apiUrl, onImageLoad, azureSasToken]);

  return null; // Componente apenas busca a imagem e não exibe nada diretamente
};

export default BuscarImagem;
